import { render } from "./Q17-Result.vue?vue&type=template&id=59af26ce&scoped=true"
import script from "./Q17-Result.vue?vue&type=script&lang=js"
export * from "./Q17-Result.vue?vue&type=script&lang=js"

import "./Q17-Result.vue?vue&type=style&index=0&id=59af26ce&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59af26ce"]])

export default __exports__